import { DropDownList } from "@repo/ui";
import { FC } from "react";

import { useRepSegmentsApi } from "../../api/repSegmentsApi";
import { useRepContext } from "../../contexts/editableItemContext";
import { useSegmentContext } from "../../contexts/segmentContext";
import style from "./style.module.scss";

export const RepSegments: FC = () => {
	const { repId } = useRepContext();
	const { useOnboardingSegmentsQuery } = useRepSegmentsApi(repId);
	const { onboardingSegments } = useOnboardingSegmentsQuery();
	const { segmentId, setSegmentId } = useSegmentContext();

	if (onboardingSegments?.length <= 1) return null;

	return (
		<DropDownList
			id="repSegment"
			label="States"
			value={segmentId}
			changeHandler={setSegmentId}
			values={onboardingSegments}
			textProp="value"
			valueProp="id"
			placeholder="Select a state"
			clearable
			className={style.dropdownList}
			fullLength
		/>
	);
};
